/**
 * Smart tenant resolver — supports both:
 *  - Subdomain routing in production: aquapure.rentalapp.com
 *  - Path-based routing for previews: /t/aquapure
 *
 * IMPORTANT: subdomain detection only runs on known production domains.
 * Preview / localhost / unknown hosts ALWAYS use path-based routing.
 */
const RESERVED_SUBDOMAINS = new Set([
  "www", "app", "api", "admin", "dashboard", "preview", "staging", "test",
]);

/** Production hosts on which subdomain → tenant routing is allowed. */
const ALLOWED_APEX_DOMAINS = [
  "rentalapp.com",
  // Add other production apex domains here when configured.
];

export function detectTenantFromHost() {
  if (typeof window === "undefined") return null;
  const host = (window.location.hostname || "").toLowerCase();
  if (!host) return null;

  // Explicit deny-list — preview/internal hosts always use path-based
  if (host === "localhost" || host.startsWith("127.") || host.endsWith(".local")) return null;
  if (host.includes("preview.") || host.endsWith(".emergentagent.com") || host.endsWith(".emergent.host")) return null;

  // Only attempt subdomain detection on known apex domains
  const matchingApex = ALLOWED_APEX_DOMAINS.find((apex) => host.endsWith(`.${apex}`) || host === apex);
  if (!matchingApex) return null;

  // host like aquapure.rentalapp.com → take the first label
  const subPart = host.slice(0, host.length - matchingApex.length - 1); // strip ".rentalapp.com"
  if (!subPart) return null;
  const sub = subPart.split(".")[0];
  if (!sub || RESERVED_SUBDOMAINS.has(sub)) return null;
  if (sub.length < 2 || sub.length > 40) return null;
  if (!/^[a-z0-9-]+$/.test(sub)) return null;
  return sub;
}

/**
 * Returns the storefront URL for a tenant slug, using subdomain in prod and path in preview.
 */
export function tenantStorefrontUrl(slug) {
  return `/t/${slug}`;
}
